const fetchData = async (difference) => {
  try {
    const body = new FormData();
    body.append('ajax_action', 'Y');

    const rawResponse = await fetch(`${window.location.pathname}?DIFFERENT=${difference ? 'Y' : 'N'}`, {
      method: 'POST',
      body,
    });

    const response = await rawResponse.text();
    return response;
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);
    return null;
  }
};

const initScripts = () => {
  window.initComparsion();
  window.initCompareDeleteItemButtons();
  window.initCompareDifferenceTOggler();
};

const makeAjaxHandler = async (evt) => {
  window.loaderShow('#bx_catalog_compare_block');

  const textHTML = await fetchData(evt.target.checked);
  const parentElem = document.getElementById('bx_catalog_compare_block');

  window.loaderHide('#bx_catalog_compare_block');
  if (textHTML && parentElem) {
    parentElem.innerHTML = textHTML;
    initScripts();
  }
};

const init = () => {
  const makeAjaxElems = document.querySelectorAll('[data-compare-page="showDifferenceToggler"]');

  makeAjaxElems.forEach((elem) => {
    if (!elem.classList.contains('_init')) {
      elem.addEventListener('change', makeAjaxHandler);
      elem.classList.add('_init');
    }
  });
};

init();

window.initCompareDifferenceTOggler = init;
